import { AuthService } from '../auth/AuthService';
import { FetchParams, Middleware, RequestContext } from './minside/runtime';

class AddTokenMiddleware implements Middleware {
  async pre?(context: RequestContext): Promise<FetchParams | void> {
    const token = await AuthService.getAccessTokenSilent();

    if (!token) {
      throw new Error('Could not obtain access token.');
    }

    const headers = context.init.headers as Record<string, string>;
    headers.Authorization = `Bearer ${token}`;

    return context;
  }
}

export default AddTokenMiddleware;
